export default __webpack_public_path__ + "diy.90691abe9703e9a19c6758a8b5d16616.png";